module.exports = __webpack_public_path__ + "static/media/vertical-tank.44e60cb6.svg";